import IconButton from '@alltrails/shared/denali/components/IconButton';
import Typography from '@alltrails/shared/denali/components/Typography';
import useToggle from '@alltrails/shared/hooks/useToggle';
import ArrowSq from '@alltrails/shared/icons/ArrowSq';
import { FormatDateOptions, FormattedMessage, useIntl } from '@alltrails/shared/react-intl';
import Modal from 'components/Modal';
import useLanguageCode from '@alltrails/shared/hooks/useLanguageCode';
import classNames from 'classnames';
import * as styles from './styles/styles.module.scss';
import alltrailsIcon from '../../../../assets/images/icons/app_icon.png';

export type ArticleCard = {
  cardType: 'article';
  logoSrc: string;
  company: string;
  title: string;
  date: string;
  href: string;
};

export type PressReleaseCard = {
  cardType: 'press-release';
  title: JSX.Element;
  date: string;
  modalContent: JSX.Element;
};

type PressCardProps = ArticleCard | PressReleaseCard;

const PressCard = (props: PressCardProps) => {
  const [isOpen, toggle] = useToggle();
  const { cardType, title, date } = props;
  const subheader = cardType === 'article' ? props.company : <FormattedMessage defaultMessage="Press release" />;

  const logoSrc = cardType === 'article' ? props.logoSrc : alltrailsIcon;

  const intl = useIntl();
  const formatOptions: FormatDateOptions = { month: 'short', day: 'numeric', year: 'numeric' };
  const languageCode = useLanguageCode();

  return (
    <div className={styles.container}>
      <div className={classNames(styles.contentContainer, { [styles.pressRelease]: cardType === 'press-release' })} lang={languageCode}>
        <div className={styles.logoContainer}>
          <img alt="" src={logoSrc} loading="lazy" />
          <Typography variant="heading200">{subheader}</Typography>
        </div>
        <Typography variant="heading400" className={styles.heading}>
          {title}
        </Typography>
      </div>
      <div className={styles.contentContainer}>
        <Typography variant="paragraph200">{intl.formatDate(date, formatOptions)}</Typography>
        {cardType === 'article' ? (
          <IconButton
            icon={{ Component: ArrowSq, orientation: 'right' }}
            testId="press-card-link"
            title="Press card link"
            size="sm"
            className={styles.iconButton}
            linkInfo={{ href: props.href, target: '_blank' }}
          />
        ) : (
          <IconButton
            icon={{ Component: ArrowSq, orientation: 'right' }}
            testId="press-card-button"
            title="Press card button"
            size="sm"
            className={styles.iconButton}
            onClick={() => toggle()}
          />
        )}
      </div>
      {cardType === 'press-release' && (
        <Modal isOpen={isOpen} onRequestClose={toggle}>
          <div className={styles.modalContainer}>
            <img alt="" src={alltrailsIcon} className={styles.modalLogo} />
            {props.modalContent}
          </div>
        </Modal>
      )}
    </div>
  );
};

export default PressCard;
